import { LazoPathsWithChat } from "@/enums/LazoPaths";
import { ConversationType, ConversationTypePath } from "@/types/ConversationType";
import { useLocation } from "react-router-dom";

const DEFAULT_TYPE = ConversationType.FUNDRAISING;

export function useConversationTypeIdentifier(): ConversationType {
  const currLocation = useLocation();

  const type = ConversationTypePath.find((o) => currLocation.pathname.includes(o.path))?.value || DEFAULT_TYPE;

  return type;
}

export function matchPathsWithChat(location: Location) {
  for (let path of LazoPathsWithChat) {
    if (location.pathname.includes(path)) {
      return true;
    }
  }
  return false;
}
